import { assetsPath } from "../../utils";

const contentPath = process.env.REACT_APP_CLOUDFRONT;
const selectPath = (str) => `${assetsPath("laguna-beachside")}${str}`;

const bubbleBeachside = {
  // url: `${contentPath}/assets/images/project-map/logo/outrigger.svg`,
  url: selectPath("/images/logo/logo-white.png"),
  width: 207,
  height: 88,
};

const bubbleOutrigger = {
  // url: `${contentPath}/assets/images/project-map/logo/outrigger.svg`,
  url: `${contentPath}/assets/images/project-map/logo/SAii_Phuket.svg`,
  width: 207,
  height: 88,
};

const bubbleCassia = {
  url: `${contentPath}/assets/images/project-map/logo/cassia.svg`,
  x: -15,
  y: -80,
  width: 212,
  height: 94,
};

const bubbleDusit = {
  url: `${contentPath}/assets/images/project-map/logo/Dusit-thani.svg`,
  width: 218,
  height: 100,
};

const bubbleHolidayClub = {
  url: `${contentPath}/assets/images/project-map/logo/laguna-holidayclub-phuketresort.svg`,
  x: -90,
  y: -10,
  width: 146,
  height: 77,
};

// const bubbleSkypark = {
//   url: `${contentPath}/assets/images/project-map/logo/phuket-skypark.svg`,
//   x: -90,
//   y: -10,
//   width: 146,
//   height: 77,
// };

const bubbleAngsanaPhuket = {
  url: `${contentPath}/assets/images/project-map/logo/angsana-laguna-phuket.svg`,
  width: 195,
  height: 57,
};

const bubbleBanyantreeSpaSanctuary = {
  url: `${contentPath}/assets/images/project-map/logo/banyan-tree-spasanctuary.svg`,
  width: 245,
  height: 56,
};

const bubbleBanyantree = {
  url: `${contentPath}/assets/images/project-map/logo/banyan-tree.svg`,
  width: 150,
  height: 69,
};

const bubbleBanyantreeDoublepoolVilla = {
  url: `${contentPath}/assets/images/project-map/logo/banyan-tree-doublepool-villa.svg`,
  width: 280,
  height: 60,
};

const bubbleAngsanaVillaResortPhuket = {
  url: `${contentPath}/assets/images/project-map/logo/angsana-villa-resort-phuket.svg`,
  width: 179,
  height: 50,
};

export default [
  // // ======================================= Hotels =======================================
  // {
  //   id: 18,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 880,
  //   y: 250,
  //   bubble: bubbleBanyantree,
  //   images: [
  //     {
  //       name: "Banyan Tree Phuket",
  //       url: `${contentPath}/assets/images/project-map/hotel/BanyanTree/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 19,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 645,
  //   y: 270,
  //   bubble: bubbleAngsanaPhuket,
  //   images: [
  //     {
  //       name: "Angsana Laguna Phuket",
  //       url: `${contentPath}/assets/images/project-map/hotel/Angsana/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 20,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 1230,
  //   y: 660,
  //   bubble: bubbleAngsanaVillaResortPhuket,
  //   images: [
  //     {
  //       name: "Angsana Villas Resort Phuket",
  //       url: `${contentPath}/assets/images/project-map/hotel/AngsanaVillas/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 21,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 460,
  //   y: 295,
  //   bubble: bubbleCassia,
  //   images: [
  //     {
  //       name: "Cassia Phuket",
  //       url: `${contentPath}/assets/images/project-map/hotel/Cassia/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 22,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 590,
  //   y: 390,
  //   bubble: bubbleHolidayClub,
  //   images: [
  //     {
  //       name: "Laguna Holiday Club Phuket Resort",
  //       url: `${contentPath}/assets/images/project-map/hotel/Laguna/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 23,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 540,
  //   y: 195,
  //   bubble: bubbleDusit,
  //   images: [
  //     {
  //       name: "Dusit Thani Laguna Phuket",
  //       url: `${contentPath}/assets/images/project-map/hotel/DusitThani/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   id: 24,
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 360,
  //   y: 220,
  //   bubble: bubbleOutrigger,
  //   images: [
  //     {
  //       name: "Outrigger Laguna Phuket Beach Resort",
  //       url: `${contentPath}/assets/images/project-map/hotel/Outrigger/1.jpg`,
  //     },
  //   ],
  // },
  // // ================================
  // {
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 440,
  //   y: 460,
  //   bubble: bubbleSkypark,
  //   images: [
  //     {
  //       name: "Skypark",
  //       url: `${contentPath}/assets/images/project-map/hotel/skypark/1.jpg`
  //     }
  //   ]
  // },
  // {
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 880,
  //   y: 250,
  //   bubble: bubbleBanyantreeSpaSanctuary,
  //   images: [
  //     {
  //       name: "Banyan Tree Spa Sanctuary",
  //       url: `${contentPath}/assets/images/project-map/hotel/SpaSanctuary/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#434a6a",
  //   group: "hotel",
  //   animated: true,
  //   x: 1007,
  //   y: 305,
  //   bubble: bubbleBanyantreeDoublepoolVilla,
  //   images: [
  //     {
  //       name: "DoublePool Villas by Banyan Tree",
  //       url: `${contentPath}/assets/images/project-map/hotel/DoublePoolVillas/1.jpg`,
  //     },
  //   ],
  // },
  // // ======================================= Restaurants =======================================
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 284,
  //   y: 171,
  //   bubble: {
  //     ...bubbleOutrigger,
  //     num: 5,
  //   },
  //   images: [
  //     {
  //       name: "Edgewater",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/1.jpg`,
  //     },
  //     {
  //       name: `Metzo's`,
  //       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/2.jpg`,
  //     },
  //     {
  //       name: "Icon Terrace & Lounge",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/3.jpg`,
  //     },
  //     {
  //       name: "Locavore",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/4.jpg`,
  //     },
  //     {
  //       name: "Voyager 47 Club Lounge",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/5.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 478,
  //   y: 196,
  //   bubble: {
  //     ...bubbleDusit,
  //     num: 5,
  //   },
  //   images: [
  //     {
  //       name: "Casuarina Beach Restaurant",
  //       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/1.jpg`,
  //     },
  //     {
  //       name: "Laguna Café",
  //       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/2.jpg`,
  //     },
  //     {
  //       name: "La Trattoria",
  //       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/3.jpg`,
  //     },
  //     {
  //       name: "Horizon Lounge",
  //       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/4.jpg`,
  //     },
  //     {
  //       name: "Ruen Thai",
  //       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/5.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 420,
  //   y: 291,
  //   bubble: {
  //     ...bubbleCassia,
  //     x: -130,
  //     num: 1,
  //   },
  //   images: [
  //     {
  //       name: "Vista Gastro - Pub",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Cassia/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 547,
  //   y: 395,
  //   bubble: {
  //     ...bubbleHolidayClub,
  //     // url: `${contentPath}/assets/images/project-map/dining-logo/Laguna.png`,
  //     // render: renderRestaurantBubble,
  //     // width: 96,
  //     num: 1,
  //   },
  //   images: [
  //     {
  //       name: "Seedling Restaurant",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Laguna/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 648,
  //   y: 287,
  //   bubble: {
  //     ...bubbleAngsanaPhuket,
  //     // url: `${contentPath}/assets/images/project-map/dining-logo/Angsana.png`,
  //     // render: renderRestaurantBubble,
  //     // width: 114,
  //     num: 6,
  //   },
  //   images: [
  //     {
  //       name: "Baan Talay",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/1.jpg`,
  //     },
  //     {
  //       name: "Bodega & Grill",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/2.jpg`,
  //     },
  //     {
  //       name: "Loy Krathong Bar",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/3.jpg`,
  //     },
  //     {
  //       name: "Market Place",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/4.jpg`,
  //     },
  //     {
  //       name: "Poolside",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/5.jpg`,
  //     },
  //     {
  //       name: "Xana Beach Club",
  //       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/6.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 926,
  //   y: 278,
  //   bubble: {
  //     ...bubbleBanyantree,
  //     // url: `${contentPath}/assets/images/project-map/dining-logo/Banyan_Tree.png`,
  //     // render: renderRestaurantBubble,
  //     // width: 102,
  //     num: 7,
  //   },
  //   images: [
  //     {
  //       name: "Banyan Café",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/1.jpg`,
  //     },
  //     {
  //       name: "Lobby Bar & Wine Rack",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/2.jpg`,
  //     },
  //     {
  //       name: "Pool Bar",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/3.jpg`,
  //     },
  //     {
  //       name: "Saffron",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/4.jpg`,
  //     },
  //     {
  //       name: "Tamarind Restaurant",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/5.jpg`,
  //     },
  //     {
  //       name: "Tre’ Restaurant",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/6.jpg`,
  //     },
  //     {
  //       name: "Watercourt",
  //       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/7.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#d68000",
  //   group: "restaurant",
  //   animated: true,
  //   x: 1208,
  //   y: 569,
  //   bubble: {
  //     ...bubbleAngsanaVillaResortPhuket,
  //     // url: `${contentPath}/assets/images/project-map/dining-logo/Angsana-villas.png`,
  //     // render: renderRestaurantBubble,
  //     width: 138,
  //     num: 2,
  //   },
  //   images: [
  //     {
  //       name: "Baan Aroi",
  //       url: `${contentPath}/assets/images/project-map/restaurant/AngsanaVillas/1.jpg`,
  //     },
  //     {
  //       name: "Panache Restaurant",
  //       url: `${contentPath}/assets/images/project-map/restaurant/AngsanaVillas/2.jpg`,
  //     },
  //   ],
  // },
  // // ======================================= Spa =======================================
  // {
  //   type: "Pin",
  //   color: "#699e84",
  //   group: "spa",
  //   animated: true,
  //   x: 443,
  //   y: 206,
  //   bubble: {
  //     text: ["ANGSANA SPA DUSIT THANI", "LAGUNA PHUKET"],
  //     width: 140,
  //     // url: `${contentPath}/assets/images/project-map/spa-logo/Dusit_Thani.png`,
  //     x: -200,
  //     y: -40,
  //   },
  //   images: [
  //     {
  //       name: "Angsana Spa Dusit Thani Laguna Phuket",
  //       url: `${contentPath}/assets/images/project-map/spa/DusitThani/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#699e84",
  //   group: "spa",
  //   animated: true,
  //   x: 634,
  //   y: 293,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/spa-logo/Angsana.png`
  //   // },
  //   bubble: {
  //     text: ["ANGSANA SPA", "LAGUNA PHUKET"],
  //     width: 80,
  //     y: -20,
  //   },
  //   images: [
  //     {
  //       name: "Angsana Spa Laguna Phuket",
  //       url: `${contentPath}/assets/images/project-map/spa/Angsana/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#699e84",
  //   group: "spa",
  //   animated: true,
  //   x: 896,
  //   y: 303,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/spa-logo/Banyan_Tree.png`
  //   // },
  //   bubble: {
  //     text: ["BANYAN TREE SPA"],
  //     width: 140,
  //     style: { fontSize: 15 },
  //   },
  //   images: [
  //     {
  //       name: "Banyan Tree Spa",
  //       url: `${contentPath}/assets/images/project-map/spa/BanyanTree/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#699e84",
  //   group: "spa",
  //   animated: true,
  //   x: 419,
  //   y: 323,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/spa-logo/Chill_Chill.png`,
  //   //   x: -150
  //   // },
  //   bubble: {
  //     text: ["CHILL CHILL SPA"],
  //     width: 120,
  //     x: -150,
  //     y: 20,
  //     style: { fontSize: 15 },
  //   },
  //   images: [
  //     {
  //       name: "Chill Chill Spa",
  //       url: `${contentPath}/assets/images/project-map/spa/ChillChill/1.jpg`,
  //     },
  //   ],
  // },
  // // ======================================= Galleries & Shopping =======================================
  // {
  //   type: "Pin",
  //   color: "#428b95",
  //   group: "gallery",
  //   animated: true,
  //   x: 514,
  //   y: 274,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Canal_Village.png`,
  //   //   x: -100,
  //   //   y: -10
  //   // },
  //   bubble: {
  //     text: ["CANAL VILLAGE", "SHOPPING"],
  //     width: 80,
  //     x: -140,
  //   },
  //   images: [
  //     {
  //       name: "Canal Village Shopping",
  //       url: `${contentPath}/assets/images/project-map/gallery/CanalVillage/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#428b95",
  //   group: "gallery",
  //   animated: true,
  //   x: 661,
  //   y: 285,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Angsana.png`,
  //   //   y: -10
  //   // },
  //   bubble: {
  //     text: ["ANGSANA", "GALLERY"],
  //     width: 60,
  //     y: -10,
  //   },
  //   images: [
  //     {
  //       name: "Angsana Gallery",
  //       url: `${contentPath}/assets/images/project-map/gallery/Angsana/1.jpg`,
  //     },
  //   ],
  // },
  // {
  //   type: "Pin",
  //   color: "#428b95",
  //   group: "gallery",
  //   animated: true,
  //   x: 870,
  //   y: 278,
  //   // bubble: {
  //   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Banyan_Tree.png`,
  //   //   y: -10
  //   // },
  //   bubble: {
  //     text: ["BANYAN TREE", "GALLERY"],
  //     width: 80,
  //     y: -10,
  //   },
  //   images: [
  //     {
  //       name: "Banyan Tree Gallery",
  //       url: `${contentPath}/assets/images/project-map/gallery/BanyanTree/1.jpg`,
  //     },
  //   ],
  // },
  // // ======================================= Bus =======================================
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 261,
  //   y: 212,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 383,
  //   y: 360,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 473,
  //   y: 255,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 421,
  //   y: 460,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 604,
  //   y: 329,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 690,
  //   y: 468,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   color: "#705c4e",
  //   group: "bus",
  //   x: 827,
  //   y: 297,
  //   animated: false,
  // },
  // // ======================================= Boat =======================================
  // {
  //   type: "Pin",
  //   label: "1",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 297.5,
  //   y: 211.5,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "2",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 408.5,
  //   y: 211.5,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "3",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 426.67,
  //   y: 230,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "4",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 396.54,
  //   y: 314,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "5",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 541.54,
  //   y: 278.5,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "6",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 595.54,
  //   y: 209.5,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "7",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 621.5,
  //   y: 219.5,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "8",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 628.54,
  //   y: 257.9,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "9",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 583.55,
  //   y: 266.57,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "10",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 645.17,
  //   y: 329,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "11",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 800,
  //   y: 255,
  //   animated: false,
  // },
  // {
  //   type: "Pin",
  //   label: "12",
  //   color: "#9f5a3a",
  //   group: "boat",
  //   x: 900,
  //   y: 268,
  //   animated: false,
  // },
];



// WEBPACK FOOTER //
// ./src/containers/ProjectMap/common-pins.js